var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"FormItemSectionTitle"},[_c('span',{staticClass:"FormItemSectionTitle__icon"},[_vm._t("icon")],2),_c('span',{staticClass:"FormItemSectionTitle__text"},[_vm._t("text")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }